const constants = {
    dev: {
        rightDeskUrlV2:"https://hontogbo.rightcom.com/rightcare-tmb",
        rightDeskUrl:"https://betarcapi.right-com.com",
        accountClientUrl:"https://accapi-v1.rightcomtech.com",
        adminApiUrl:"https://adminapi-v1.rightcomtech.com",
        cdnUrl:"https://cdn.rightcomtech.com",
        cdnToken:"Dcfb51409eb9f42f8b87e2f0248573f03D",
    },
    prod: {
        rightDeskUrlV2:"https://hontogbo.rightcom.com/rightcare-tmb",
        rightDeskUrl:"https://rightcareapi.rightcom.co",
        accountClientUrl:"https://accapi-v1.rightcom.co",
        adminApiUrl:"https://adminapi-v1.rightcom.co",
        cdnUrl:"https://cdn.right-com.com",
        cdnToken:"Dcfb51409eb9f42f8b87e2f0248573f03D",
    }
}

export default constants